import { Media } from '@kiwicom/account-global-contexts';
import { Layout, Skeleton } from '@kiwicom/orbit-components';
import { useIntl } from 'react-intl';

const PreferencesPlaceholder = (): JSX.Element => {
  const intl = useIntl();

  return (
    <Layout type="MMB">
      <Media greaterThanOrEqual="tablet">
        <Skeleton
          width="100%"
          height={700}
          dataTest="PriceAlert-123"
          title={intl.formatMessage({
            id: 'common.loading',
            defaultMessage: 'Loading',
          })}
        >
          <rect x="0%" rx="4" ry="3" y="6" height="24" width="18%" />
          <rect x="0%" rx="4" ry="3" y="60" height="130" width="48%" />
          <rect x="50%" rx="4" ry="3" y="60" height="130" width="50%" />
          <rect x="0%" rx="4" ry="3" y="206" height="130" width="48%" />
          <rect x="50%" rx="4" ry="3" y="206" height="130" width="50%" />
          <rect x="0%" rx="4" ry="3" y="352" height="130" width="48%" />
          <rect x="50%" rx="4" ry="3" y="352" height="130" width="50%" />
        </Skeleton>
      </Media>
      <Media lessThan="tablet">
        <Skeleton
          width="100%"
          height={700}
          dataTest="PriceAlert-123"
          title={intl.formatMessage({
            id: 'common.loading',
            defaultMessage: 'Loading',
          })}
        >
          <rect x="0%" rx="4" ry="3" y="8" height="24" width="22%" />
          <rect x="0%" rx="4" ry="3" y="60" height="130" width="100%" />
          <rect x="0%" rx="4" ry="3" y="206" height="130" width="100%" />
          <rect x="0%" rx="4" ry="3" y="351" height="130" width="100%" />
          <rect x="0%" rx="4" ry="3" y="497" height="130" width="100%" />
        </Skeleton>
      </Media>
    </Layout>
  );
};

export default PreferencesPlaceholder;
